import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { OrganizationRoleRow } from "src/pages/Settings/Users/OrganizationRolesSection/OrganizationRoleRow";
import { OrganizationRoleCompany } from "src/pages/Settings/Users/OrganizationRolesSection/types";

type OrganizationRolesTableProps = {
    companies: OrganizationRoleCompany[];
    isRolesLoading?: boolean;
    canManageRoles: boolean;
    onEdit: (company: OrganizationRoleCompany, roles: string[]) => void;
    onRemove: (company: OrganizationRoleCompany) => void;
};

export const OrganizationRolesTable = (props: OrganizationRolesTableProps) => {
    const { companies, isRolesLoading, canManageRoles, onEdit, onRemove } = props;
    const { t } = useTranslation();

    if (companies.length === 0) {
        return (
            <Box
                sx={{
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    borderRadius: "8px",
                    padding: (theme) => theme.spacing(3),
                    backgroundColor: "background.paper",
                }}
            >
                <Typography variant="small-medium" sx={{ color: "text.disabled" }}>
                    {t("users.organizationRolesEmpty", "No company roles assigned")}
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer
            sx={{
                border: (theme) => `1px solid ${theme.palette.divider}`,
                borderRadius: "8px",
                backgroundColor: "background.paper",
            }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t("users.organizationRolesCompanyHeader", "Company")}</TableCell>
                        <TableCell>{t("users.organizationRolesRolesHeader", "Roles")}</TableCell>
                        {canManageRoles && (
                            <TableCell align="right">{t("users.organizationRolesActionsHeader", "Actions")}</TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {companies.map((company) => (
                        <OrganizationRoleRow
                            key={`organization-role-row-${company.id}`}
                            company={company}
                            roles={company.roles ?? []}
                            isRolesLoading={isRolesLoading}
                            canManageRoles={canManageRoles}
                            onEdit={onEdit}
                            onRemove={onRemove}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
